"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDragScroll = void 0;

var _react = require("react");

var useDragScroll = function useDragScroll(_ref) {
  var viewport = _ref.viewport,
      thumbRef = _ref.thumbRef,
      scrollWidth = _ref.scrollWidth,
      trackWidth = _ref.trackWidth,
      scrollLeft = _ref.scrollLeft,
      clientWidth = _ref.clientWidth;
  var isDown = (0, _react.useRef)(false);
  var startX = (0, _react.useRef)(0);
  var offsetX = (0, _react.useRef)(0);
  (0, _react.useEffect)(function () {
    if (!viewport || !(thumbRef !== null && thumbRef !== void 0 && thumbRef.current)) return;
    var thumb = thumbRef.current;

    var handleMouseDown = function handleMouseDown(event) {
      event.stopPropagation();
      isDown.current = true;
      startX.current = event.pageX;
      offsetX.current = viewport.scrollLeft;
    };

    var handleMouseUp = function handleMouseUp() {
      isDown.current = false;
      startX.current = 0;
    };

    var handleMouseMove = function handleMouseMove(event) {
      if (!isDown.current) return;
      var delta = (event.pageX - startX.current) * scrollWidth / trackWidth;
      viewport.scrollLeft = offsetX.current + delta;
    };

    thumb.addEventListener("mousedown", handleMouseDown);
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    return function () {
      thumb.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [viewport, clientWidth, scrollWidth, scrollLeft, trackWidth, thumbRef]);
};

exports.useDragScroll = useDragScroll;